// Service Dependencies
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';


@Injectable()
export class PostalCodesService {

  apiUrl: string;

  constructor(
    private http: HttpClient,
  ) {
    this.apiUrl = AppSettings.API_PROD_ENDPOINT;
  }

  getPostalCodesByMunicipality(municipality: string): Observable<string []> {
    const body = JSON.stringify({ municipality });
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    const requestUrl = this.apiUrl + `db-postal-codes/filter-by-municipality`;

    return this.http.post(requestUrl, body, { headers })
      .pipe(
        take(1),
        map((res: string []) => res),
        catchError((err: HttpErrorResponse) => {
          console.error('Status: ', err.status, ', Error: ', err.error);
          return throwError(err);
        })
      );
  }

 
}
